const transfers = {
  transfer: "Überweisen", // translated
  transfers: "Überweisungen", // translated
  dateAndTime: "Datum (und Uhrzeit", // translated
  transferFrom: "Übertragen von", // translated
  duration: "Dauer", // translated
  numOfPersons: "Personenzahl", // translated
  baggageAllowance: "Freigepäck", // translated
  small: "Klein", // translated
  big: "Groß", // translated
  provider: "Anbieter", // translated
  vehicle: "Fahrzeug", // translated
  distance: "Distanz", // translated
  price: "Preis", // translated
  inboundJourney: "Inbound-Reise", // translated
  outboundJourney: "Ausgehende Reise", // translated
  arrivalTime: "Ankunftszeit", // translated
  flightDetails: "Flugdaten", // translated
  inboundPickupDate: "Datum der eingehenden Abholung", // translated
  outboundPickupDate: "Abholdatum für den Hinflug", // translated
  travelInfo: "Reiseinformationen", // translated
  flightsInfo: "Fluginformationen", // translated
  airportYouAreFlyingFrom: "Flughafen, von dem aus Sie fliegen", // translated
  airportYouAreFlyingTo: "Flughafen, zu dem Sie fliegen", // translated
  inboundFlightNumber: "Nummer des eingehenden Fluges", // translated
  outboundFlightNumber: "Nummer des Hinflugs", // translated
  inboundAirlineName: "Name der ankommenden Fluggesellschaft", // translated
  outboundAirlineName: "Name der ausgehenden Fluggesellschaft", // translated
  tripMode: "Reisemodus", // translated
  airportToPoint: "Flughafen zum Punkt", // translated
  pointToAirport: "Zeigen Sie auf den Flughafen", // translated
  roundTrip: "Rundfahrt", // translated
  destinationPoint: "Bestimmungsort", // translated
  originPoint: "Ursprungspunkt", // translated
  transferType: "Übertragungsart", // translated
  min: "Mindest", // translated
  max: "Max", // translated
  pieces: "Stücke", // translated
  cancelationIs: "Stornierung ist", // translated
};


export default transfers;
